export class EmailValidator {
  static isValid (email) {
    /* eslint-disable-next-line */
    return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)
  }
}



// WEBPACK FOOTER //
// ./src/services/emailValidator.service.js